import React from 'react';
import DateRangeContext from '../context/DateRangeContext/DateRangeContext';
import DateRangeContextType from '../context/DateRangeContext/DateRangeContextType';

function useDateRange(): DateRangeContextType {
  const context = React.useContext(DateRangeContext);
  if (context === undefined) {
    throw new Error('useDateRange must be used within a DateRangeProvider');
  }
  return context;
}

export default useDateRange;
